@if (offer(); as o) {
	<div class="u-card u-card--float">
		<p class="u-title">
			<span class="icon-circle">
				<tvcore-icon name="checkmark"></tvcore-icon>
			</span>
			{{ 'BOOKING.SUBMITTED.TITLE' | translate }}
		</p>

		<hr class="u-m-top--md u-m-bottom--md" />

		<p class="u-text--bold u-m-bottom--sm">{{ 'BOOKING.SUBMITTED.CONTENT_TITLE' | translate }}</p>

		<ul class="u-m-bottom--sm">
			@if ('BOOKING.SUBMITTED.CONTENT_ITEMS' | translate; as ITEMS) {
				@for (ITEM of ITEMS; track ITEM) {
					<li>{{ ITEM }}</li>
				}
			}
		</ul>

		<p class="u-m-bottom--sm">
			{{ (o.type === OffersType.ACCOMMODATION ? 'BOOKING.SUBMITTED.CONTENT_FOOTER_ACCOMMODATION' : 'BOOKING.SUBMITTED.CONTENT_FOOTER') | translate }}
		</p>

		@if (o.type === OffersType.ACCOMMODATION) {
			<tvcore-message class="u-m-bottom--sm" icon="info" [sm]="true">
				<p class="u-title-group u-m-bottom--tiny">{{ 'BOOKING.SUBMITTED.PUBLIC_TRANSPORT.TITLE' | translate }}</p>
				<p [innerHTML]="'BOOKING.SUBMITTED.PUBLIC_TRANSPORT.CONTENT' | translate"></p>
			</tvcore-message>
		}

		<a [routerLink]="['/', 'offers', o.id]" class="c-btn">{{ 'BOOKING.SUBMITTED.CLOSE_BUTTON' | translate }}</a>
	</div>
}
